import AddAlertsConfigInfoDialog from './addAlertsConfigInfoDialog';
export default AddAlertsConfigInfoDialog;